var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-navigation-drawer', {
    staticClass: "app-sidebar",
    attrs: {
      "app": "",
      "fixed": "",
      "permanent": "",
      "value": "true",
      "height": _vm.navHeight
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": "grey lighten-2"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "d-flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      },
      "tag": "button"
    }
  }, [_c('v-row', {
    staticClass: "mx-0 align-center"
  }, [_c('v-col', {
    staticClass: "app-logo pb-0 pt-2 px-0"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo/app_logo.svg"),
      "alt": "Multinet",
      "width": "100%"
    }
  })]), _c('v-col', {
    staticClass: "text-left"
  }, [_vm._v(" Multinet ")]), _c('v-col', {
    staticClass: "pa-0"
  }, [_c('about-dialog')], 1)], 1)], 1)], 1), _c('v-spacer'), _c('login-menu', {
    attrs: {
      "store": _vm.store,
      "oauth-client": _vm.oauthClient,
      "user-info": _vm.userInfo
    }
  })], 1), _c('WorkspaceDialog'), _c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "fixed-tabs": "",
      "hide-slider": ""
    },
    model: {
      value: _vm.tabSelected,
      callback: function ($$v) {
        _vm.tabSelected = $$v;
      },
      expression: "tabSelected"
    }
  }, [_c('v-tab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.userInfo !== null,
      expression: "userInfo !== null"
    }],
    staticStyle: {
      "width": "126px"
    }
  }, [_vm._v(" Your workspaces ")]), _c('v-tab', {
    staticStyle: {
      "width": "126px"
    }
  }, [_vm._v(" Public workspaces ")])], 1), _c('v-divider'), _c('v-tabs-items', {
    model: {
      value: _vm.tabSelected,
      callback: function ($$v) {
        _vm.tabSelected = $$v;
      },
      expression: "tabSelected"
    }
  }, _vm._l([false, true], function (publicSpace) {
    return _c('div', {
      key: publicSpace
    }, [_c('v-tab-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.userInfo !== null || publicSpace,
        expression: "userInfo !== null || publicSpace"
      }]
    }, [_c('v-list-item-group', {
      attrs: {
        "color": "primary"
      }
    }, _vm._l(_vm.workspaces, function (space) {
      return _c('v-hover', {
        key: space.name,
        scopedSlots: _vm._u([{
          key: "default",
          fn: function (_ref) {
            var hover = _ref.hover;
            return space.public === publicSpace ? _c('v-list-item', {
              attrs: {
                "ripple": "",
                "to": ("/workspaces/" + (space.name) + "/")
              }
            }, [_c('v-list-item-action', {
              on: {
                "click": function ($event) {
                  $event.preventDefault();
                }
              }
            }, [!hover && !_vm.checkbox[space.name] ? _c('v-icon', {
              staticClass: "workspace-icon"
            }, [_vm._v(" mdi-text-box-multiple ")]) : _c('v-checkbox', {
              staticClass: "ws-checkbox",
              model: {
                value: _vm.checkbox[space.name],
                callback: function ($$v) {
                  _vm.$set(_vm.checkbox, space.name, $$v);
                },
                expression: "checkbox[space.name]"
              }
            })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(space.name))])], 1)], 1) : _vm._e();
          }
        }], null, true)
      });
    }), 1), _c('delete-workspace-dialog', {
      ref: "dws",
      refInFor: true,
      attrs: {
        "something-checked": _vm.somethingChecked,
        "selection": _vm.selection
      },
      on: {
        "deleted": _vm.workspaceDeleted,
        "closed": function ($event) {
          _vm.singleSelected = null;
        }
      }
    })], 1)], 1);
  }), 0), _vm.loading ? _c('div', [_c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  })], 1) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }